import React, { ComponentProps } from 'react';
import { asWidgetProps } from 'Src/types/widget-helpers';
import { get } from 'lodash';
import { messageFormat as message } from '@clubmed/utils';
import { ICONS } from 'Components/utils/icon/icons';
import { t } from 'Src/i18n';
import { getAgencyDetails, isPastTrip, getTranportIcon } from 'Utils/ple-utils/bookingUtils';
import { TravelDetail } from 'Components/widgets/travel-details/travel-detail/TravelDetail';
type Props = {
  arrivalCity: string;
  bookingStatus: string;
  className?: string;
  departureCity: string;
  isJoyview: boolean | null | undefined;
  returnDate: string;
  transportType?: string;
  vendor?: BookingVendor;
};
const formatCallToUpsellTransportLabel = ({ isJoyview, vendor }: Props) => {
  const callToUpsellTransportLabel = t('booking.form.callToUpsellTransportLabel');
  const params = {
    dedicatedJoyviewHotlineNumber: t('stays.agency.joyviewHotlineNumber'),
    isJoyview,
    vendor,
  };
  const agencyDetails = getAgencyDetails(params);
  return callToUpsellTransportLabel
    ? message(callToUpsellTransportLabel).format({
        agencyNumber: get(agencyDetails, 'label', ''),
      })
    : '';
};
export const TransportTravelDetails = (props: Props) => {
  const { arrivalCity, bookingStatus, className, departureCity, returnDate, transportType } = props;
  const hasTransport = departureCity && arrivalCity;
  const isSearch = bookingStatus === 'SEARCH';
  if (!hasTransport) {
    const highlightText =
      isPastTrip(returnDate) || isSearch ? '' : formatCallToUpsellTransportLabel(props);
    return (
      <TravelDetail
        {...asWidgetProps<ComponentProps<typeof TravelDetail>>({
          className: className,
          icon: ICONS.NO_TRANSPORT,
          infos: {
            text1: t('booking.form.withoutTransport'),
            highlightText2: highlightText,
          },
        })}
      />
    );
  }
  return (
    <TravelDetail
      {...asWidgetProps<ComponentProps<typeof TravelDetail>>({
        className: className,
        icon: getTranportIcon(transportType),
        infos: {
          text1: t('common.duration.from'),
          highlightText1: departureCity,
          text2: t('common.duration.to'),
          highlightText2: arrivalCity,
        },
      })}
    />
  );
};
